// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div[data-v-1233a067]{margin:2em 1.4em;text-align:center}a[data-v-1233a067]{align-items:flex-start;display:flex;flex-wrap:wrap;gap:1.5em;justify-content:center;-webkit-text-decoration:none;text-decoration:none}img[data-v-1233a067]{height:auto;max-width:100%;width:270px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
